import axios from "axios";
import mentoriaApi from "../../../services/axiosTokenMiddleware";

const mentoriaURL = process.env.REACT_APP_MENTORIA_FINANCIERA_URL || "";
const mentoriaApiKey = process.env.REACT_APP_MENTORIA_APIKEY_TOKEN || "";
const tokenURL = process.env.REACT_APP_TOKEN_URL || "";
const apikeySFIN = process.env.REACT_APP_MENTORIA_FINANCIERA_API_KEY || "";

export const getToken = async (uid: string) => {
	const data = JSON.stringify({
		"UID": uid,
		"action": "getJWT"
	});

	try {
		const response = await axios.post(tokenURL, data, {
			headers: {
				"Content-Type": "application/json",
				"apikey": mentoriaApiKey
			},
		});
		return response?.data.data.id_token;
	} catch (error) {
		console.error(error);
	}
};

export const getPointsByUser = async () => {
	return mentoriaApi.get(mentoriaURL + "getPointsByUser", {
		headers: {
			"Content-Type": "application/json",
			"ApiKey": apikeySFIN
		},
	});
};

export const getPurposeByUser = async () => {
	return mentoriaApi.get(mentoriaURL + "getPrincipalPurpose", {
		headers: {
			"Content-Type": "application/json",
			"ApiKey": apikeySFIN
		},
	});
};